export const ContractTableTrackingAction = {
    configureRenewal: 'marketplace.contracts.table.configureRenewal',
} as const;

export type ContractTableTrackingActionValue =
    (typeof ContractTableTrackingAction)[keyof typeof ContractTableTrackingAction];

const configureRenewalTrackingKey = 'intl-msg:common-message.contracts.configureRenewal';

function toTrackingSegment(value: string) {
    return value
        .trim()
        .replace(/[^A-Za-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

function appendTrackingSegment(baseTrackingKey: string, serviceName: string) {
    const trackingLabel = toTrackingSegment(serviceName);
    return trackingLabel ? `${baseTrackingKey}.${trackingLabel}` : baseTrackingKey;
}

export function getContractTableAutoTrackingKey(action: ContractTableTrackingActionValue, serviceName: string) {
    return appendTrackingSegment(action, serviceName);
}

export function getConfigureRenewalAutoTrackingKey(serviceName: string) {
    return appendTrackingSegment(configureRenewalTrackingKey, serviceName);
}
